import { apiRequest } from "./ApiUtility";

export async function getDiagrams(authContext, serviceId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/diagram/all/${serviceId}`;

  return await apiRequest("get", url, authContext);
}

export async function getDiagramById(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/diagram/${id}`;

  return await apiRequest("get", url, authContext);
}

export async function createDiagram(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/diagram`;

  return await apiRequest("post", url, authContext, data);
}

export async function updateDiagram(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/diagram`;

  return await apiRequest("put", url, authContext, data);
}

export async function deleteDiagram(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/diagram/${id}`;

  return await apiRequest("delete", url, authContext);
}